import { BaseUrlConstantsService } from '../../../app/services/base-url-constants.service';
import { BackendApiService } from '../../../app/services/backend-api.service';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Component, OnInit,Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators,NonNullableFormBuilder,FormControl } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { ReactiveFormsModule } from '@angular/forms';
import { OvenDeviceListComponent } from '../oven-device-list/oven-device-list.component'; 


interface OvenFormModel {
  name: FormControl<string>;
  serialNumber: FormControl<string>;
  gatewayAddress: FormControl<string>;
  site: FormControl<string>;
  application: FormControl<string>;
}

@Component({
  selector: 'app-define-oven',
  standalone: true,
  imports: [ CommonModule,FormsModule,MatInputModule,
    MatFormFieldModule,
    MatButtonModule,
    MatCardModule,
    ReactiveFormsModule,],
  templateUrl: './define-oven.component.html',
  styleUrl: './define-oven.component.scss'
})

export class DefineOvenComponent {
  private getApplicationsUrl = BaseUrlConstantsService.GET_APPLICATION;
  public  ovenBaseApi = BaseUrlConstantsService.OVEN_BASE_URL;
  private  allSitesUrl = BaseUrlConstantsService.GET_SITES;
  public addSubsystem = BaseUrlConstantsService.eBoilerRoomApi;
  public gatewayAdresses = BaseUrlConstantsService.eBoilerRoomApi;
  public getGnericSerialNo = BaseUrlConstantsService.BASE_MIDDLEWARE_SELF;
  public sitesList:any =[];
  public showList: boolean;
  public emptyMsg: boolean;
  public userRoll: string;
  public applicationList: any;
  public selectedApplication: any;
  public selectedSite: any;
  public selectedgateway: any;
  public ovenName: string = "";
  public clientId: any;
  public serialNumber :string = "";
    subsystemId: any;
    siteName: any;
    applicationName: any;
    public gatewayAddressesList: any =[];
    public ovenForm: FormGroup<OvenFormModel>;
  siteId: string;
  applicationId: string;
  inventoryId: string;
  public tabName: any = "tab-7";
  public tab1: boolean = false;
  public tab2: boolean = true;
  public tab3: boolean = true;
  public tab4: boolean = true;

 public product_type_id: any;
  public genericSerialNo: string;
  public newgenericSerialNo: string;
    constructor(private service: BackendApiService, private fb: NonNullableFormBuilder,
      @Inject(MAT_DIALOG_DATA) public data : {client_id:any, product_id:any}, 
      public router: Router, public dialogRef: MatDialogRef<OvenDeviceListComponent>) {
          
       }
  
    ngOnInit(): void {
      this.clientId = localStorage.getItem('user_id');
      this.userRoll = localStorage.getItem('role');
      this.getGatewayAddress();
      this.getPreviousSerialNo();
      this.getallSitesAndGroupsInfo(this.data['client_id']);
      this.initForm();
      console.log(this.selectedSite,'selected site',this.data.product_id);
    }
    form: FormGroup;
    submitted = false;
    loading = false;
    
    
    initForm(): void {
      this.ovenForm =this.fb.group({
        name: new FormControl('', { nonNullable: true, validators: Validators.required }),
        serialNumber: new FormControl('', { nonNullable: true, validators: Validators.required }),
        gatewayAddress: new FormControl('', { nonNullable: true, validators: Validators.required }),
        site: new FormControl('', { nonNullable: true, validators: Validators.required }),
        application: new FormControl('', { nonNullable: true, validators: Validators.required }),
      });
      
    }
  
    get f() { return this.form.controls; }
  
    onSubmit(): void {
      this.submitted = true;
      console.log(this.isFormValid(),this.ovenForm)
      // if (!this.isFormValid()) {
      //   return;
      // }
      this.siteId = this.ovenForm.value.site;
      this.applicationId = this.ovenForm.value.application;
      this.inventoryId = this.ovenForm.value.serialNumber;
      this.loading = true;
      console.log(this.ovenForm)
      // Simulate API call
      this.addSubsystemFun();
      // setTimeout(() => {
      //   console.log('Form submitted:', this.ovenForm.value);
      //   this.loading = false;
      //   this.submitted = false;
      //   this.form.reset();
      //   // Show success message
      //   alert('Form submitted successfully!');
      // }, 1500);
    }
    getallSitesAndGroupsInfo(clientid) {
      this.service.getData(this.allSitesUrl + "/" + Math.floor(Math.random() * 90 + 10) + clientid + Math.floor(Math.random() * 9000 + 1000)).then((res) => {
        if (JSON.parse(JSON.stringify(res)).data.status === "success") {
          if(JSON.parse(JSON.stringify(res)).data.body.length !== 0){
            this.sitesList = JSON.parse(JSON.stringify(res)).data.body;
          }else {
            this.service.showError("Something went wrong.");
          }
        } else {
          this.service.showError("Something went wrong.");
        }
      });
    }
  //get application
    async getGroupsBySiteId(siteId: any) {
      let body;
      if (this.userRoll === "USER") {
        body = {
          client_id: localStorage.getItem("client_id"),
          user_id: localStorage.getItem("user_id"),
          site_id: siteId,
        };
      } else {
        body = {
          client_id: localStorage.getItem("user_id"),
          site_id: siteId,
        };
      }
      this.service
        .getData(
          this.getApplicationsUrl +
          "/" +
          localStorage.getItem("user_id") +
          "/" +
          siteId
        )
        .then((res) => {
          if (JSON.parse(JSON.stringify(res)).data.status === "success") {
            if (JSON.parse(JSON.stringify(res)).data.body.length !== 0) {
              this.applicationList = JSON.parse(JSON.stringify(res)).data.body;
            } else {
             
            }
          } else {
            this.service.showError("Something went wrong.");
          }
        });
    }
  
    onClose(){
      this.dialogRef.close();
  
    }
  
    isFormValid() {
      return (this.ovenForm.value.name,this.ovenForm.value.serialNumber,this.ovenForm.value.gatewayAddress,this.ovenForm.value.site,this.ovenForm.value.application);
    }
  
  onSiteSelected(siteId){
    this.getGroupsBySiteId(siteId);
  }
  
  //add subsystem
    addSubsystemFun(){
      const body = {
        "type":"custom-oven",
        "name": this.ovenForm.value.name,
        "site_id": this.ovenForm.value.site,
        "mac_address" : this.ovenForm.value.gatewayAddress,
        "application_id": this.ovenForm.value.application,
        "client_id": this.clientId,
        "product_id": this.data.product_id,
        // "inventory_id": response.device_id,
      }
      this.dialogRef.close();
      this.service.postData(`${this.addSubsystem}eboiler/add`,body)
      .then((res:any) =>{
        let response = res.data;
        if(response.status === 'success'){
          console.log()
          let body ={
            user_id: this.clientId,
            product_type_id: 7,
            device_sno: this.newgenericSerialNo,
            subsystem_id: response.id,
            site_id: this.ovenForm.value.site,
            application_id: this.ovenForm.value.application,
            inventory_id: response.device_id,
            name: this.ovenForm.value.name
          }
          this.service.postData(`${this.ovenBaseApi}api/v1/oven-assets/create`,body)
          .then((response:any) =>{

            const navigationExtras = {
              skipLocationChange: true,
              queryParams:
                {
                  pageRef: "oven-device",
                  tabName: this.tabName,
                  tab1: this.tab1,
                  tab2 : this.tab2,
                  tab3 : this.tab3,
                  tab4 :this.tab4,
    
                 }
            };
            this.subsystemId = response.id;
            this.ovenName = response.name;
            this.siteName = response.siteName;
            this.applicationName = response.applicationName;
            let userRoll = localStorage.getItem("role");
            if(userRoll=='CLIENT' || userRoll=='USER')
              this.router.navigate(['/device-reports'],navigationExtras)
            else if(userRoll=='ADMIN'){
              this.router.navigate(['/device-report-new'],navigationExtras)
            }
          })
          }else{
            this.service.showError("Something went wrong.");
          }
        
      });
    }
  
    //get gateway address
  
    getGatewayAddress(){
      this.service.getData(this.gatewayAdresses + "gateway_address/" + Math.floor(Math.random() * 90 + 10) + this.clientId + Math.floor(Math.random() * 9000 + 1000))
      .then(res => {
        let response = JSON.parse(JSON.stringify(res)).data;
        if(response.status === "success"){
          if(response.body.length != 0){
            this.gatewayAddressesList = response.body;
            console.log(response,'dddddddddddddseeeeeeeeeeeeeee')

          }
        }
      })
    }

    getPreviousSerialNo(){
      this.service.getData(`${this.getGnericSerialNo}generic_asset/${this.data['product_type_id']}`)
      .then((res:any) =>{
        let response = res.data;
        if(response.status === "success"){
            if(response.body?.body?.length === 0){
              this.genericSerialNo = "";
            }else{
              this.genericSerialNo = response.body.device_sno;
            }
        }else{
          this.genericSerialNo = "";
        }
      })
    }

 onGatewayChange(event: any) {
  const selectedMac = event.target.value; // just the MAC string
  const selectedGateway = this.gatewayAddressesList.find(
    g => g.mac_address === selectedMac
  );


  let selectedAbbr = selectedGateway.abbreviation;
  if (!this.genericSerialNo || this.genericSerialNo === "") {
    // First time → start fresh
    this.genericSerialNo = selectedAbbr + "OA01";
  } else {
    // Example current: RIOA01 → want only prefix(2) + letter + number
    let letter = this.genericSerialNo.charAt(this.genericSerialNo.length - 3); // "A"
    let number = parseInt(this.genericSerialNo.slice(-2), 10);                 // 01

    if (number < 99) {
      number++;
      this.genericSerialNo =
        selectedAbbr +"O"+ letter + number.toString().padStart(2, "0");
    } else {
      // rollover case: XX...A99 → XX...B01
      let nextLetter = String.fromCharCode(letter.charCodeAt(0) + 1);
      this.genericSerialNo = selectedAbbr +"O"+ nextLetter + "01";
    }
  }
  this.newgenericSerialNo = this.genericSerialNo;
  console.log("Updated Serial:", this.newgenericSerialNo);
}
}
